//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";
export default {
  name: "vHeader",
  data() {
    return {
      activeIndex: "1",
      activeIndex2: "1",
      centerDialogVisible: false,
      user: sessionStorage.getItem("user"),
      password: ""
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      //   console.log(key, keyPath);
    },
    changePassword() {
      this.centerDialogVisible = false;
      if (this.user == "" || this.password == "") {
        this.$message({
          message: "用户名或者密码不能为空",
          type: "warning"
        });
      } else {
        const loading = this.$loading();
        axios.defaults.headers = {
          Authorization: sessionStorage.getItem("Authorization")
        };
        let formTmp = new FormData();
        formTmp.append("type", "changePassword");
        formTmp.append("user", this.user);
        formTmp.append("password", this.password);
        axios.post(this.$apiUrl, formTmp).then(data => {
          // console.log(data.data);
          if (data.data.success == true) {
            loading.close();
            this.$message({
              message: data.data.msg,
              type: "success"
            });
            this.$router.push("/login");
          }
        });
      }
    },
    loginOut() {
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("Authorization");
      sessionStorage.removeItem("time");
      this.$router.push("/login");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/Header.vue